import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a56160a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "common-balance-tab" }
const _hoisted_2 = {
  key: 0,
  src: "https://static-jp.theckb.com/static-asset/client/balance/main_icon_active.png",
  alt: ""
}
const _hoisted_3 = {
  key: 1,
  src: "https://static-jp.theckb.com/static-asset/client/balance/main_icon_active_b2b.png",
  alt: ""
}
const _hoisted_4 = {
  key: 1,
  src: "https://static-jp.theckb.com/static-asset/client/balance/main_icon.png",
  alt: ""
}
const _hoisted_5 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_6 = ["src"]
const _hoisted_7 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  src: "https://static-jp.theckb.com/static-asset/client/balance/son_icon_active.png",
  alt: ""
}
const _hoisted_10 = {
  key: 1,
  src: "https://static-jp.theckb.com/static-asset/client/balance/son_icon_active_b2b.png",
  alt: ""
}
const _hoisted_11 = {
  key: 1,
  src: "https://static-jp.theckb.com/static-asset/client/balance/son_icon.png",
  alt: ""
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"1"} }, null, -1))
const _hoisted_13 = {
  key: 2,
  class: "common-balance-tab-tip"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-jp.theckb.com/static-asset/client/balance/help_icon.png",
  alt: ""
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "口座を切り替えてご利用ください", -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { class: "common-balance-main" }
const _hoisted_18 = {
  key: 0,
  class: "common-balance-tip"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-jp.theckb.com/static-asset/client/balance/wanring_icon.png",
  alt: ""
}, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ご注文", -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode("には")
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "店舗", -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode("口座、会員費・出金には")
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "管理", -1))
const _hoisted_25 = /*#__PURE__*/_createTextVNode("口座をご利用ください ")
const _hoisted_26 = [
  _hoisted_19,
  _hoisted_20,
  _hoisted_21,
  _hoisted_22,
  _hoisted_23,
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = {
  key: 1,
  class: "common-balance-change-shop"
}
const _hoisted_28 = {
  key: 0,
  src: "https://static-jp.theckb.com/static-asset/client/balance/shop_icon.png",
  alt: ""
}
const _hoisted_29 = {
  key: 1,
  src: "https://static-jp.theckb.com/static-asset/client/balance/shop_icon_b2b.png",
  alt: ""
}
const _hoisted_30 = { class: "name" }
const _hoisted_31 = ["src"]
const _hoisted_32 = { class: "flex-ter gap-[4px] text-[8px]" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "h-[12px] translate-y-[1px] ,mr-[5px]",
  style: {"height":"10px"},
  src: "https://static-s.theckb.com/BusinessMarket/SEO/choice-logo.png",
  alt: ""
}, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#606266","font-size":"8px","margin-left":"4px"} }, "商品購入可", -1))
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = { class: "common-balance-btn" }
const _hoisted_37 = { class: "btn-list" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: "https://static-jp.theckb.com/static-asset/client/balance/balance_icon_1.png",
  alt: "",
  style: {"display":"inline-block"}
}, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: "https://static-jp.theckb.com/static-asset/client/balance/balance_icon_2.png",
  alt: "",
  style: {"display":"inline-block"}
}, null, -1))
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { style: {"max-width":"244px","font-size":"14px"} }
const _hoisted_43 = { class: "title" }
const _hoisted_44 = { class: "text rel" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, null, -1))
const _hoisted_47 = {
  key: 0,
  src: "https://static-jp.theckb.com/static-asset/client/balance/warning_tip_icon.png",
  alt: "",
  style: {"width":"16px","margin-left":"8px"}
}
const _hoisted_48 = { style: {"display":"inline-block"} }
const _hoisted_49 = {
  key: 0,
  referrerPolicy: "no-referrer",
  src: "https://static-jp.theckb.com/static-asset/client/balance/balance_icon_3.png",
  alt: "",
  style: {"display":"inline-block"}
}
const _hoisted_50 = {
  key: 1,
  referrerPolicy: "no-referrer",
  src: "https://static-jp.theckb.com/static-asset/client/balance/balance_icon_3_b2b.png",
  alt: "",
  style: {"display":"inline-block"}
}
const _hoisted_51 = { class: "flex flex-end" }
const _hoisted_52 = { class: "common-balance-recharge-content" }
const _hoisted_53 = { class: "recharge-item" }
const _hoisted_54 = { class: "recharge-item-title" }
const _hoisted_55 = { class: "title" }
const _hoisted_56 = { class: "text" }
const _hoisted_57 = {
  key: 1,
  class: "title"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"max-width":"244px","font-size":"14px"} }, [
  /*#__PURE__*/_createTextVNode(" ※この残高は直接注文に使えません。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("店舗口座へ振替後、ご注文いただけます。 ")
], -1))
const _hoisted_59 = { class: "recharge-item-price" }
const _hoisted_60 = { class: "price" }
const _hoisted_61 = { class: "unit" }
const _hoisted_62 = { class: "jpy" }
const _hoisted_63 = {
  key: 0,
  class: "recharge-item-tip"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "※ 会員費の支払い・出金は管理口座から行われます ", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "※ 店舗口座へ振替して注文にご利用ください", -1))
const _hoisted_66 = [
  _hoisted_64,
  _hoisted_65
]
const _hoisted_67 = {
  key: 1,
  class: "recharge-item-tip"
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "※ 注文や店舗関連費用の支払いに使用されます ", -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "※ 親アカウント（管理口座）との間で振替が可能です", -1))
const _hoisted_70 = [
  _hoisted_68,
  _hoisted_69
]
const _hoisted_71 = { class: "fund-amount-icon" }
const _hoisted_72 = {
  key: 0,
  referrerPolicy: "no-referrer",
  src: "https://static-jp.theckb.com/static-asset/client/balance/recharge_d2c_icon.png",
  alt: ""
}
const _hoisted_73 = {
  key: 1,
  referrerPolicy: "no-referrer",
  src: "https://static-jp.theckb.com/static-asset/client/balance/recharge_b2b_icon.png",
  alt: ""
}
const _hoisted_74 = {
  key: 0,
  class: "recharge-item"
}
const _hoisted_75 = {
  key: 0,
  class: "recharge-item-title"
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "チャージ申請中", -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "（審査待ち）", -1))
const _hoisted_78 = [
  _hoisted_76,
  _hoisted_77
]
const _hoisted_79 = {
  key: 1,
  class: "recharge-item-title"
}
const _hoisted_80 = { class: "title" }
const _hoisted_81 = { class: "recharge-item-price" }
const _hoisted_82 = { class: "price" }
const _hoisted_83 = { class: "unit" }
const _hoisted_84 = { class: "jpy" }
const _hoisted_85 = { class: "fund-amount-icon" }
const _hoisted_86 = {
  key: 0,
  referrerPolicy: "no-referrer",
  src: "https://static-jp.theckb.com/static-asset/client/balance/recharge_d2c_icon2.png",
  alt: ""
}
const _hoisted_87 = {
  key: 1,
  referrerPolicy: "no-referrer",
  src: "https://static-jp.theckb.com/static-asset/client/balance/recharge_b2b_icon2.png",
  alt: ""
}
const _hoisted_88 = {
  key: 1,
  class: "recharge-item"
}
const _hoisted_89 = { class: "recharge-item-title" }
const _hoisted_90 = { class: "title" }
const _hoisted_91 = { class: "recharge-item-price" }
const _hoisted_92 = { class: "price" }
const _hoisted_93 = { class: "unit" }
const _hoisted_94 = { class: "jpy" }
const _hoisted_95 = { class: "fund-amount-icon" }
const _hoisted_96 = {
  key: 0,
  referrerPolicy: "no-referrer",
  src: "https://static-jp.theckb.com/static-asset/client/balance/recharge_d2c_icon2.png",
  alt: ""
}
const _hoisted_97 = {
  key: 1,
  referrerPolicy: "no-referrer",
  src: "https://static-jp.theckb.com/static-asset/client/balance/recharge_b2b_icon2.png",
  alt: ""
}

import UploadBillExcel from './UploadBillExcel.vue'
import { myShopIcons } from '@/store/modules/bussiness'
import { getFundColumns, getSubFundColumns, tableConfig, formatPrice, secondFlowType } from '../data'
import BalanceLowerSet from './balanceLowerSet.vue'
import { t, lang } from '@/plugins/i18n'
import { isD2C, isEN, isJA, isMultiStore, useRtfix } from '@/store'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import { calc, formatMoneyDirection } from '@/util/useYan'
import SelectIcon from '@/views/usercenter/ProductList/components/SelectIcon.vue'
import { useStore } from 'vuex'

export default /*#__PURE__*/_defineComponent({
  props: [
  'fundTab',
  'isSub',
  'currencyCode',
  'showTransfer',
  'exportExcel',
  // 账户余额
  'accountBalance',
  'unCheckMoneyJPY',
  'wfPriceJPY',
  'unCheckMoney',
  'wfPrice',
  'customerShopName',
  'changeFundCountry',
  'changeTab',
  'frozenAmount'
],
  setup(__props) {

const props = __props
const store = useStore()
const router = useRouter()

const FundCountry = [
  { value: 'CNY', label: t('人民币钱包'), logo: 'https://static-s.theckb.com/BusinessMarket/Client/country/ChinaSquareIcon@3x.png' },
  { value: 'KRW', label: t('韩元钱包'), logo: 'https://static-s.theckb.com/BusinessMarket/Client/country/KoreaSquareIcon@3x.png' }
]
const getSelectInfo = () => {
  const selectInfo = FundCountry.find((item) => item.value === props.currencyCode)
  return selectInfo
}
const shops = computed(() => store.getters.userShops)
const curShop = computed(() => store.getters.curShop)
const shopId = ref()
const changeShopFn = () => {
  store.dispatch('route/changeShop', shopId.value)
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["common-balance-content", _unref(isD2C)() ? '' : 'b2b'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!_unref(isMultiStore)())
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["common-balance-tab-item", { active: __props.fundTab === '1' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.changeTab('1')))
          }, [
            (__props.fundTab === '1')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_unref(isD2C)())
                    ? (_openBlock(), _createElementBlock("img", _hoisted_2))
                    : (_openBlock(), _createElementBlock("img", _hoisted_3))
                ], 64))
              : (_openBlock(), _createElementBlock("img", _hoisted_4)),
            _createElementVNode("span", null, _toDisplayString(_unref(isJA)() ? '親アカウント（管理口座）' : _unref(t)('主钱包')), 1)
          ], 2))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["common-balance-tab-item", { active: __props.fundTab === '1' }])
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                style: {"display":"flex","align-items":"center"},
                onClick: _cache[1] || (_cache[1] = ($event: any) => (__props.changeTab('1')))
              }, [
                _createElementVNode("img", {
                  style: {"width":"21px","margin-right":"4px"},
                  src: getSelectInfo()?.logo,
                  alt: ""
                }, null, 8, _hoisted_6),
                _createElementVNode("span", null, _toDisplayString(getSelectInfo()?.label), 1)
              ]),
              _createVNode(_component_el_select, {
                size: "small",
                style: {"width":"30px"},
                class: "select-no-border-special-nolabel",
                "popper-class": `select-no-border-special-popper-nolabel-fund${_unref(lang)}`,
                "model-value": __props.currencyCode,
                onChange: __props.changeFundCountry,
                "suffix-icon": SelectIcon
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(FundCountry, (country) => {
                    return _createVNode(_component_el_option, {
                      size: "small",
                      key: country.value,
                      label: country.label,
                      value: country.value
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("img", {
                            style: {"width":"21px","margin-right":"4px"},
                            src: country.logo,
                            alt: ""
                          }, null, 8, _hoisted_8),
                          _createElementVNode("span", null, _toDisplayString(country.label), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["label", "value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["popper-class", "model-value", "onChange"])
            ])
          ], 2)),
      _createElementVNode("div", {
        class: _normalizeClass(["common-balance-tab-item", { active: __props.fundTab === '2' }]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (__props.changeTab('2')))
      }, [
        (__props.fundTab === '2')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_unref(isD2C)())
                ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                : (_openBlock(), _createElementBlock("img", _hoisted_10))
            ], 64))
          : (_openBlock(), _createElementBlock("img", _hoisted_11)),
        _createElementVNode("span", null, _toDisplayString(_unref(isJA)() ? '子アカウント（店舗別口座）' : _unref(t)('子钱包') + '(' + __props.customerShopName + ')'), 1)
      ], 2),
      _hoisted_12,
      (_unref(isJA)())
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_17, [
      (_unref(isJA)() && __props.fundTab === '1')
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_26))
        : _createCommentVNode("", true),
      (_unref(isJA)() && __props.fundTab === '2')
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            (_unref(isD2C)())
              ? (_openBlock(), _createElementBlock("img", _hoisted_28))
              : (_openBlock(), _createElementBlock("img", _hoisted_29)),
            _createElementVNode("span", _hoisted_30, "対象店舗：" + _toDisplayString(_unref(shops).find((v) => v.customerShopId === _unref(curShop))?.customerShopName), 1),
            _createVNode(_component_el_select, {
              class: "select-shop-name",
              modelValue: shopId.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((shopId).value = $event)),
              ref: (_value, _refs) => {
                _refs['select'] = _value
              },
              placeholder: "店舗を切り替える",
              onChange: changeShopFn
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(shops), (v) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: v.customerShopId,
                    value: v.customerShopId,
                    label: v.customerShopName
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "flex-ter shop-item",
                        style: _normalizeStyle(v.supportChoice && 'line-height: 18px;')
                      }, [
                        _createElementVNode("img", {
                          referrerPolicy: "no-referrer",
                          src: _unref(myShopIcons)[v.shopPlatform],
                          class: "mr_5",
                          style: {"width":"20px"}
                        }, null, 8, _hoisted_31),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", null, _toDisplayString(v.customerShopName), 1),
                          _withDirectives(_createElementVNode("span", _hoisted_32, _hoisted_35, 512), [
                            [_vShow, v.supportChoice]
                          ])
                        ])
                      ], 4)
                    ]),
                    _: 2
                  }, 1032, ["value", "label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          (!__props.isSub && __props.fundTab === '1')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "btn-item",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(router).push(_unref(useRtfix)('Recharge', { query: { currencyCode: __props.currencyCode } })))),
                style: {"display":"inline-block"}
              }, [
                _hoisted_38,
                _createElementVNode("span", null, _toDisplayString(_unref(t)('充值')), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "btn-item blue rel",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (__props.showTransfer && __props.showTransfer(...args)))
          }, [
            _hoisted_39,
            (_unref(isJA)())
              ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(__props.fundTab === '2' ? '管理口座へ振替' : '店舗口座へ振替'), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_unref(t)('转账')), 1)),
            (_unref(isJA)() && __props.fundTab === '1')
              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 2,
                  effect: "light",
                  placement: "top",
                  "popper-class": "tool-tip-no-border"
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, _toDisplayString(_unref(t)('待付款提醒')), 1),
                      _createElementVNode("div", _hoisted_44, [
                        _createTextVNode(_toDisplayString(_unref(t)('発注は店舗で行いますので、')), 1),
                        _hoisted_45,
                        _createTextVNode(_toDisplayString(_unref(t)('ご注文前に、まず振替による店舗へ資金を移動する必要があります')), 1)
                      ]),
                      _hoisted_46
                    ])
                  ]),
                  default: _withCtx(() => [
                    (__props.fundTab === '1')
                      ? (_openBlock(), _createElementBlock("img", _hoisted_47))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_48, [
            (__props.fundTab === '2')
              ? (_openBlock(), _createBlock(UploadBillExcel, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: "btn-item green",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (__props.exportExcel && __props.exportExcel(...args)))
          }, [
            (_unref(isD2C)())
              ? (_openBlock(), _createElementBlock("img", _hoisted_49))
              : (_openBlock(), _createElementBlock("img", _hoisted_50)),
            _createElementVNode("span", null, _toDisplayString(_unref(t)('表格导出')), 1)
          ]),
          _createElementVNode("div", _hoisted_51, [
            (!__props.isSub)
              ? (_openBlock(), _createBlock(BalanceLowerSet, { key: 0 }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            (_unref(isJA)())
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("span", _hoisted_55, _toDisplayString(__props.fundTab === '1' ? '管理口座残高' : '店舗口座残高'), 1),
                  _createElementVNode("span", _hoisted_56, _toDisplayString(__props.fundTab === '1' ? '（チャージ・会費・出金用）' : '（注文・支払いに使用）'), 1)
                ], 64))
              : (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(_unref(t)('可用余额')), 1)),
            (_unref(isJA)() && __props.fundTab === '1')
              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 2,
                  effect: "light",
                  placement: "top",
                  "popper-class": "tool-tip-no-border"
                }, {
                  content: _withCtx(() => [
                    _hoisted_58
                  ]),
                  default: _withCtx(() => [
                    _createVNode(SvgIcon, {
                      name: "提示",
                      style: {"font-size":"16px","margin-left":"6px","color":"#000"}
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("span", _hoisted_60, _toDisplayString(_unref(formatPrice)(__props.accountBalance)), 1),
            _createElementVNode("span", _hoisted_61, _toDisplayString(__props.currencyCode
              === 'KRW' ? _unref(t)("KRW") : _unref(t)("元")), 1),
            _createElementVNode("span", _hoisted_62, "(" + _toDisplayString(_unref(formatMoneyDirection)(_unref(formatPrice)(_unref(calc)(__props.accountBalance, __props.currencyCode)))) + ")", 1)
          ]),
          (_unref(isJA)())
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (__props.fundTab === '1')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_63, _hoisted_66))
                  : (_openBlock(), _createElementBlock("div", _hoisted_67, _hoisted_70))
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_71, [
            (_unref(isD2C)())
              ? (_openBlock(), _createElementBlock("img", _hoisted_72))
              : (_openBlock(), _createElementBlock("img", _hoisted_73))
          ])
        ]),
        (__props.fundTab === '1')
          ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
              (_unref(isJA)())
                ? (_openBlock(), _createElementBlock("div", _hoisted_75, _hoisted_78))
                : (_openBlock(), _createElementBlock("div", _hoisted_79, [
                    _createElementVNode("span", _hoisted_80, _toDisplayString(_unref(t)('未入账金额')), 1)
                  ])),
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("span", _hoisted_82, _toDisplayString(_unref(formatPrice)((__props.unCheckMoney + __props.wfPrice)?.toFixed?.(2)) || 0), 1),
                _createElementVNode("span", _hoisted_83, _toDisplayString(__props.currencyCode
              === 'KRW' ? _unref(t)("KRW") : _unref(t)("元")), 1),
                _createElementVNode("span", _hoisted_84, "(" + _toDisplayString(_unref(formatMoneyDirection)(_unref(formatPrice)((__props.unCheckMoneyJPY +
              __props.wfPriceJPY)?.toFixed?.(_unref(isEN)() ? 2 : 0) || 0))) + ")", 1)
              ]),
              _createElementVNode("div", _hoisted_85, [
                (_unref(isD2C)())
                  ? (_openBlock(), _createElementBlock("img", _hoisted_86))
                  : (_openBlock(), _createElementBlock("img", _hoisted_87))
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_88, [
              _createElementVNode("div", _hoisted_89, [
                _createElementVNode("span", _hoisted_90, _toDisplayString(_unref(t)('冻结金额')), 1)
              ]),
              _createElementVNode("div", _hoisted_91, [
                _createElementVNode("span", _hoisted_92, _toDisplayString(_unref(formatPrice)(__props.frozenAmount)), 1),
                _createElementVNode("span", _hoisted_93, _toDisplayString(__props.currencyCode
              === 'KRW' ? _unref(t)("KRW") : _unref(t)("元")), 1),
                _createElementVNode("span", _hoisted_94, "(" + _toDisplayString(_unref(formatMoneyDirection)(_unref(formatPrice)(_unref(calc)(__props.frozenAmount,
              __props.currencyCode)))) + ")", 1)
              ]),
              _createElementVNode("div", _hoisted_95, [
                (_unref(isD2C)())
                  ? (_openBlock(), _createElementBlock("img", _hoisted_96))
                  : (_openBlock(), _createElementBlock("img", _hoisted_97))
              ])
            ]))
      ])
    ])
  ], 2))
}
}

})